import { type ReactNode } from "react";

import * as DialogPrimitive from "@radix-ui/react-dialog";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { NotificationCenterCount } from "./NotificationCenterCount";
import { NotificationCenterHeader } from "./NotificationCenterHeader";
import { NotificationCenterList } from "./NotificationCenterList";

type Props = {
  children?: ReactNode;
  className?: string;
};

export const NotificationCenterPanel = ({ children, className }: Props) => (
  <DialogPrimitive.Portal>
    <DialogPrimitive.Content
      aria-describedby={undefined}
      className={cnTwMerge(
        "fixed inset-0 w-full sm:inset-auto sm:top-4 sm:right-4 sm:bottom-auto sm:w-[28rem] sm:max-h-[calc(100vh-2rem)] z-modal flex flex-col bg-background/card sm:rounded-default border-0 sm:border-1 border-border/primary shadow-popover outline-none overflow-hidden",
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:slide-in-from-right data-[state=closed]:slide-out-to-right duration-200",
        className,
      )}
      data-testid="notification-center-panel"
      onInteractOutside={(event) => {
        const target = event.target as HTMLElement | null;

        if (target?.closest('[role="menu"]')) {
          event.preventDefault();
        }
      }}
    >
      {children ?? (
        <>
          <NotificationCenterHeader />
          <NotificationCenterList />
          <NotificationCenterCount />
        </>
      )}
    </DialogPrimitive.Content>
  </DialogPrimitive.Portal>
);
